import * as React from 'react';
import styled from 'styled-components';
import MuiInputAdornment, { InputAdornmentProps as MuiInputAdornmentProps } from '@material-ui/core/InputAdornment';

const StyledAdornment = styled(MuiInputAdornment)``;

export type DSInputAdornmentProps = MuiInputAdornmentProps;
export const DSInputAdornment: React.FC<DSInputAdornmentProps> = props => <StyledAdornment {...props} />;
DSInputAdornment.displayName = 'DSInputAdornment';
